import apiClient from './client'

export const authService = {
  login: (credentials) => apiClient.post('/login', credentials),

  register: (data) => apiClient.post('/register', data),

  logout: () => apiClient.post('/logout'),

  getProfile: () => apiClient.get('/profile'),

  updateProfile: (data) => apiClient.put('/profile', data),

  uploadProfilePhoto: (file) => {
    const formData = new FormData()
    formData.append('photo', file)
    return apiClient.post('/profile/photo', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  changePassword: (data) => apiClient.put('/password', data),
}

export default authService
